module.exports = __webpack_public_path__ + "static/media/cnn.com_2016_11_07_politics_live-election-results-coverage_index.html_plot.78a7ca3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/cnn.com_2016_11_07_politics_live-election-results-coverage_index.html_plot.png
// module id = 382
// module chunks = 0